import { AI_ARCHITECTURE } from "../content";
import { AiSectionHead } from "./AiSection";

/**
 * 五层方案架构（纯 CSS 卡片矩阵，无图片依赖）。对应设计稿第 4 节。
 * L5→L1 自上而下，L4/L3、L3/L2、L2/L1 之间有向下箭头；
 * tone=accent 为品牌蓝浅底强调格，tone=core 为深底核心格（运行时底座）。
 */
export default function AiArchitecture() {
  return (
    <section id="ai-architecture" aria-labelledby="ai-arch-h" className="py-14 lg:py-20 scroll-mt-20">
      <AiSectionHead eyebrow={AI_ARCHITECTURE.eyebrow} title={AI_ARCHITECTURE.title} sub={AI_ARCHITECTURE.sub} />
      <div className="rounded-3xl overflow-hidden border border-gray-200 bg-white shadow-[0_4px_14px_rgba(13,31,60,0.08)]">
        {/* 顶部内网标注条 */}
        <div className="flex flex-wrap items-center gap-3 px-6 py-4 bg-[#0b1b3d] text-white/80 text-xs">
          <span className="font-bold text-[#4db8ff] tracking-wide">{AI_ARCHITECTURE.barLeft}</span>
          <span className="flex-1 min-w-[12px] h-px bg-white/12"></span>
          <span>{AI_ARCHITECTURE.barRight}</span>
        </div>
        <div className="p-6 lg:p-8 grid gap-4">
          {AI_ARCHITECTURE.layers.map((layer, li) => {
            const showArrowAfter = li >= 1 && li <= AI_ARCHITECTURE.layers.length - 2;
            return (
              <div key={layer.key}>
                <div className="grid gap-4 lg:gap-5 md:grid-cols-[132px_minmax(0,1fr)] items-stretch">
                  <div className="flex md:flex-col justify-center items-center gap-1 md:text-center p-4 rounded-[10px] bg-[#f8fafc] border border-gray-200">
                    <span className="font-mono text-[11px] font-bold text-[#1a56db] tracking-[0.08em]">{layer.key}</span>
                    <span className="text-xs font-bold text-[#0d1f3c]">{layer.label}</span>
                  </div>
                  <div className="grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))" }}>
                    {layer.cells.map((cell) => {
                      const cls =
                        cell.tone === "core"
                          ? "bg-[#060e1e] border-[#4db8ff]/28 text-white/80 [&_.arch-ct]:text-white"
                          : cell.tone === "accent"
                            ? "bg-gradient-to-br from-[#1a56db]/7 to-[#22d3ee]/6 border-[#1a56db]/28 [&_.arch-ct]:text-[#1a56db]"
                            : "bg-white border-gray-200";
                      return (
                        <div key={cell.title} className={`p-4 rounded-[10px] border text-xs leading-relaxed text-[#475569] ${cls}`}>
                          <span className="arch-ct block text-sm font-bold text-[#0d1f3c] mb-0.5">{cell.title}</span>
                          {cell.desc}
                        </div>
                      );
                    })}
                  </div>
                </div>
                {showArrowAfter && (
                  <div className="grid place-items-center text-[#4db8ff] text-lg h-6" aria-hidden>
                    <i className="ri-arrow-down-double-line"></i>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
